import { createContext, useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

// Where a task's decision controls (Approve / Reject / Skip, Mark reviewed, publish status) render.
// The conversation view provides an element pinned above its message box, so the decision never
// scrolls away with the conversation; everywhere else there is no target and they render in place.
const DecisionTargetContext = createContext<HTMLElement | null>(null);

export const DecisionTargetProvider = DecisionTargetContext.Provider;

export function DecisionSlot({ children }: { children: ReactNode }) {
  const target = useContext(DecisionTargetContext);
  return target ? createPortal(children, target) : <>{children}</>;
}
